import React from 'react';

interface StarProps {
    isSelected?: boolean;
    onSelected?: () => void;
}

interface StarState { }

export default class Star extends React.Component<StarProps, StarState> {
    public constructor(props: StarProps) {
        super(props);
    }

    public render(): React.ReactNode {
        const isSelected = this.props.isSelected ?? false;

        return <div onClick={() => this.props.onSelected?.call(this)}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill='none' xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 2.5L15.31 8.96L22.5 9.79L17.13 14.61L18.82 21.71L12.5 18.08L6.18 21.71L7.87 14.61L2.5 9.79L9.69 8.96L12.5 2.5Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill={isSelected ? '#94ad34' : 'none'}
                        strokeLinecap="round"
                        strokeLinejoin="round"/>
            </svg>
        </div>;
    }
}